import { baseRoutes } from '@routes/helpers/baseRoutes.ts';
import { routesPaths } from '@routes/helpers/constants.ts';
import { AppRouteConfig } from '@routes/route';

export const learningCenterRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: baseRoutes.learningCenter.root,
    lazyImport: () => import('../../domains/protected/learning-center/LearningCenterRoute.tsx'),
    requiresAuth: true,
    resourceId: 'program',
    children: [
      {
        index: true,
        lazyImport: () =>
          import('../../domains/protected/learning-center/pages/learning-center-list/LearningCenterListRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.learningCenter.history,
        lazyImport: () =>
          import('../../domains/protected/learning-center/pages/history/history-list/LearningCenterHistoryRoute.tsx'),
        nav: {
          backTo: routesPaths.learningCenter.root,
          breadcrumbKey: 'history'
        }
      },
      {
        path: baseRoutes.learningCenter.details,
        lazyImport: () =>
          import('../../domains/protected/learning-center/pages/learning-center-details/LearningCenterDetailsRoute.tsx'),
        nav: {
          backTo: routesPaths.learningCenter.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.learningCenter.historyDetails,
        lazyImport: () =>
          import('../../domains/protected/learning-center/pages/history/history-details/LearningCenterHistoryDetailsRoute.tsx'),
        nav: {
          backTo: routesPaths.learningCenter.history,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.learningCenter.newResponse,
        lazyImport: () =>
          import('../../domains/protected/learning-center/pages/response/ResponseRoute.tsx'),
        nav: {
          backTo: routesPaths.learningCenter.details(':id'),
          breadcrumbKey: 'details'
        }
      },
      {
        path: ':id/responses/:responseId',
        lazyImport: () => import('../components/OutletRoute.tsx'),
        children: [
          {
            path: baseRoutes.learningCenter.responseDetails,
            lazyImport: () =>
              import('../../domains/protected/learning-center/pages/response/ResponseRoute.tsx'),
            nav: {
              backTo: routesPaths.learningCenter.details(':id'),
              breadcrumbKey: 'details'
            }
          }
        ]
      },
      {
        path: '*',
        redirectTo: baseRoutes.learningCenter.root
      }
    ]
  }
];
